import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  ReferenceBook,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const powerRateTariffTypesApi = createApi({
  reducerPath: 'powerRateTariffTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/power-rate-tariff-types`,
  }),
  tagTypes: ['PowerRateTariffType'],
  endpoints: builder => ({
    getPowerRateTariffTypes: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '/' }),
      providesTags: () => ['PowerRateTariffType'],
    }),
    getPowerRateTariffTypesI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['PowerRateTariffType'],
    }),
  }),
});

export const { useGetPowerRateTariffTypesQuery } = powerRateTariffTypesApi;

export const useGetPowerRateTariffTypesInfiniteQuery =
  normalizeInfiniteQueryData(
    powerRateTariffTypesApi.useGetPowerRateTariffTypesIInfiniteQuery,
  );
